
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Dumbbell } from "lucide-react";
import { AddFacilityDialog } from "./AddFacilityDialog";
import { FacilityCard } from "./FacilityCard";
import { Facility } from "@/hooks/useFacilities";

interface FacilitiesManagementProps {
  providerId: string;
  facilities: Facility[];
  facilitiesLoading: boolean;
  onFacilityUpdated: () => void;
}

const FacilitiesManagement = ({ 
  providerId, 
  facilities, 
  facilitiesLoading, 
  onFacilityUpdated 
}: FacilitiesManagementProps) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0">
          <CardTitle className="flex items-center space-x-2">
            <Dumbbell className="h-5 w-5" />
            <span>Facilities</span>
          </CardTitle>
          <AddFacilityDialog 
            providerId={providerId} 
            onFacilityAdded={onFacilityUpdated} 
          />
        </div>
      </CardHeader>
      
      <CardContent>
        {facilitiesLoading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="h-64 bg-gray-200 rounded animate-pulse"></div>
            ))}
          </div>
        ) : facilities && facilities.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {facilities.map((facility) => (
              <FacilityCard 
                key={facility.id} 
                facility={facility}
                onFacilityUpdated={onFacilityUpdated}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <Dumbbell className="h-12 w-12 mx-auto mb-4 text-gray-300" />
            <p>No facilities created yet</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default FacilitiesManagement;
